import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import useQSBuilder from "../../hooks/useQSBuilder";
import { ApplicationSettingsQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import {
  ApplicationSettingsQueryString,
  IApplicationSetting,
} from "../../models/ApplicationSettings/ApplicationSettings";

export default function useApplicationSettings(
  ids: ApplicationSettingsQueryString
) {
  const buildQs = useQSBuilder();
  const { get } = useApiHelper();

  const applicationSettings = useQuery({
    queryKey: ApplicationSettingsQueryKeys.byAppOrAppRegId(ids),
    queryFn: () =>
      get<IDefaultResponse<IApplicationSetting[]>>(
        `/applicationsetting${buildQs(ids)}`
      ).then((res) => res.data),
  });

  return {
    applicationSettings,
  };
}
